export default __webpack_public_path__ + "static/AmazonGiftCardBanner.001-56f04c9e5fd456cff51e8c50802a3209.png";